import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { classnames, classname } from 'utils';

import './Popup.css';

class Popup extends Component {
  cl = classname('popup');

    static propTypes = {
  // / Доп. класс */
    className: PropTypes.string,
  // / Значение */
    values: PropTypes.object,
    /** Событие изменения значения */
    onChange: PropTypes.func
  };

  render() {
    const { className, values, onCloseButtonClick } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <div className={classes} data-component='popup'>
        <div className={this.cl('wrapper')} data-component='popup'>
          <div className={` ${this.cl('stats')} ${this.cl('stats')}--knowledge`} data-component='popup'>
            <p className={this.cl('stats-index')} data-component='popup'>{values.knowledge}</p>
            <p className={this.cl('stats-subtitle')} data-component='popup'>знание</p>
          </div>
          <div className={` ${this.cl('stats')} ${this.cl('stats')}--partnership`} data-component='popup'>
            <p className={this.cl('stats-index')} data-component='popup'>{values.partnership}</p>
            <p className={this.cl('stats-subtitle')} data-component='popup'>сотрудничество</p>
          </div>
          <div className={` ${this.cl('stats')} ${this.cl('stats')}--quality`} data-component='popup'>
            <p className={this.cl('stats-index')} data-component='popup'>{values.quality}</p>
            <p className={this.cl('stats-subtitle')} data-component='popup'>качество</p>
          </div>
          <button
            className={this.cl('close-button')}
            onClick={onCloseButtonClick}
            aria-label='Закрыть окно'
          />
        </div>
      </div>
    );
  }
}

export default Popup;
